import { render, staticRenderFns } from "./PermissionsSettings.vue?vue&type=template&id=77248704&scoped=true"
import script from "./PermissionsSettings.vue?vue&type=script&lang=js"
export * from "./PermissionsSettings.vue?vue&type=script&lang=js"
import style0 from "./PermissionsSettings.vue?vue&type=style&index=0&id=77248704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77248704",
  null
  
)

export default component.exports